import React from "react";
import { PillIcon } from "../../../Icons";
import { pharmacyApi } from "../../../services/librariesCatalogService";
import LibraryCatalogPage from "../components/LibraryCatalogPage";
import PharmacyFormModal from "./PharmacyFormModal";

const columns = [
  {
    header: "Pharmacy Name",
    accessor: "pharmacyName",
    sortable: true,
    strong: true,
    className: "whitespace-nowrap px-3 min-w-[10rem]",
  },
  {
    header: "Address",
    accessor: "address",
    className: "px-3 max-w-[16rem]",
    render: (row) => {
      const line = [row.address, row.city, row.state, row.zip]
        .filter(Boolean)
        .join(", ");
      return (
        <span className="text-[13px] text-slate-700 block truncate" title={line}>
          {line || "—"}
        </span>
      );
    },
  },
];

const PharmacyDirectoryPage = () => (
  <LibraryCatalogPage
    title="Pharmacy Directory"
    icon={PillIcon}
    addLabel="Create New"
    searchPlaceholder="Search by name, address, city..."
    entityLabel="Pharmacy"
    defaultSortBy="pharmacyName"
    api={pharmacyApi}
    columns={columns}
    FormModal={PharmacyFormModal}
    getDeleteLabel={(row) => row.pharmacyName}
  />
);

export default PharmacyDirectoryPage;
